import {BaseValidatedClass} from './BaseValidatedClass';

interface ExternalSmartElementsLibraryMap {
  openSmartElementsLibrary(_onDataSelectCallback: ExternalSmartElementSelectCallback, _onCancelCallback: ExternalSmartElementCancelCallback): void;
}

export type ExternalSmartElement = Record<string, string>;

export type ExternalSmartElementSelectCallback = (smartElement: ExternalSmartElement) => void;
export type ExternalSmartElementCancelCallback = () => void;
export class ExternalSmartElementsLibrary extends BaseValidatedClass implements ExternalSmartElementsLibraryMap {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalSmartElementsLibraryMap)[] = ['openSmartElementsLibrary'];

  constructor() {
    super(ExternalSmartElementsLibrary.REQUIRED_METHODS, ExternalSmartElementsLibrary);
  }

  public openSmartElementsLibrary(_onDataSelectCallback: ExternalSmartElementSelectCallback, _onCancelCallback: ExternalSmartElementCancelCallback): void {
    throw new Error('Method openSmartElementsLibrary() must be implemented by the subclass');
  }
}
